"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var lodash_1 = require("lodash");
var qs_1 = tslib_1.__importDefault(require("qs"));
var HttpService_1 = tslib_1.__importDefault(require("./lib/HttpService"));
Promise.prototype.offline = function (callback) {
    var P = this;
    return P.catch(function (value) {
        var val = callback(value);
        if ((0, lodash_1.isObject)(val) && (0, lodash_1.isFunction)(val.then) && (0, lodash_1.isFunction)(val.catch)) {
            return val;
        }
        else {
            return Promise.resolve(val);
        }
    });
};
var WebHttpService = /** @class */ (function (_super) {
    tslib_1.__extends(WebHttpService, _super);
    function WebHttpService(options) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this) || this;
        _this.retryRequests = [];
        _this.baseUrl = options.baseUrl;
        _this.timeout = (_a = options.timeout) !== null && _a !== void 0 ? _a : 60000;
        _this.whiteList = (_b = options.whiteList) !== null && _b !== void 0 ? _b : [];
        _this.loginOut = options === null || options === void 0 ? void 0 : options.loginOut;
        _this.errMapCommon = options === null || options === void 0 ? void 0 : options.errMapCommon;
        _this.errMap = options === null || options === void 0 ? void 0 : options.errMap;
        _this.errorMessage = options === null || options === void 0 ? void 0 : options.errMessage;
        _this.isOffline = options === null || options === void 0 ? void 0 : options.isOffline;
        _this.native = (_c = options === null || options === void 0 ? void 0 : options.native) !== null && _c !== void 0 ? _c : false;
        _this.retryRequests = [];
        _this.isCsrfTokenRefreshing = false;
        _this.retryCount = 0;
        _this.maxRetryCount = 20;
        _this.cookiePrefix = (_d = options === null || options === void 0 ? void 0 : options.cookiePrefix) !== null && _d !== void 0 ? _d : '';
        _this.instance = _this.createAxiosInstance();
        return _this;
    }
    WebHttpService.prototype.createAxiosInstance = function () {
        var _this = this;
        var instance = axios_1.default.create({
            baseURL: this.baseUrl,
            timeout: this.timeout,
            validateStatus: function (status) {
                return status >= 200 && status <= 504;
            },
        });
        instance.interceptors.request.use(function (config) {
            if (!_this.native) {
                var cookieToken = _this.cookiePrefix + 'token';
                js_cookie_1.default.get(cookieToken) && (config.headers['X-Auth-Token'] = js_cookie_1.default.get(cookieToken));
            }
            if (config.method === 'get') {
                config.paramsSerializer = function (params) {
                    return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
                };
            }
            return config;
        }, function (error) { return Promise.reject(error); });
        instance.interceptors.response.use(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, config_1, csrfTokenResult;
            var _this = this;
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = response.data;
                        if (!(response.status === 200)) return [3 /*break*/, 11];
                        if (!(data && data.status === 'fail')) return [3 /*break*/, 9];
                        if (!(data.result === 'csrfTokenErr')) return [3 /*break*/, 7];
                        this.retryCount++;
                        if (this.retryCount > this.maxRetryCount) {
                            return [2 /*return*/, Promise.reject(response)];
                        }
                        config_1 = response.config;
                        if (!!this.isCsrfTokenRefreshing) return [3 /*break*/, 5];
                        this.isCsrfTokenRefreshing = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, instance.post('/getCSRFToken')];
                    case 2:
                        csrfTokenResult = _c.sent();
                        if (((_a = csrfTokenResult === null || csrfTokenResult === void 0 ? void 0 : csrfTokenResult.data) === null || _a === void 0 ? void 0 : _a.status) === 'success' && csrfTokenResult.data.result) {
                            this.retryRequests.forEach(function (cb) { return cb(); });
                            this.retryRequests = [];
                            return [2 /*return*/, instance(config_1)];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.isCsrfTokenRefreshing = false;
                        return [7 /*endfinally*/];
                    case 4: return [3 /*break*/, 6];
                    case 5: return [2 /*return*/, new Promise(function (resolve) {
                            _this.retryRequests.push(function () { resolve(instance(config_1)); });
                        })];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (data.result === 'authErr') {
                            if (this.loginOut && !this.native) {
                                this.loginOut();
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(response)];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        _c.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        if (((_b = response.config) === null || _b === void 0 ? void 0 : _b.url) !== '/getCSRFToken') { // 非getCSRFToken请求成功 重置
                            this.retryCount = 0;
                        }
                        _c.label = 10;
                    case 10:
                        if (data instanceof Blob) {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/, Promise.resolve(response)];
                    case 11:
                        if (response.status === 400) {
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        else {
                            return [2 /*return*/, Promise.reject(response)];
                        }
                        _c.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        }); });
        return instance;
    };
    WebHttpService.prototype.get = function (name, params, _a) {
        var _this = this;
        if (params === void 0) { params = {}; }
        var _b = _a === void 0 ? {
            errCode: '',
            config: {},
        } : _a, errCode = _b.errCode, config = _b.config;
        var path = (0, lodash_1.isObject)(name) ? name.url : name;
        return this.instance.get(path, tslib_1.__assign({ params: params }, config)).then(function (res) {
            if (_this.native || (config === null || config === void 0 ? void 0 : config.native)) {
                return Promise.resolve(res);
            }
            else {
                if (res.data && res.data.status === 'fail' && res.data.result !== 'authErr') {
                    if (_this.whiteList.find(function (val) { return val.name === path && val.err.find(function (item) { return item === res.data.result; }); })) {
                    }
                    else {
                        res.data.result = _this.errMsg(res.data.result, errCode) || res.data.result;
                    }
                }
                return Promise.resolve(res.data);
            }
        });
    };
    WebHttpService.prototype.post = function (name, data, _a, config) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var _b = _a === void 0 ? {
            errCode: '',
        } : _a, errCode = _b.errCode;
        if (config === void 0) { config = {}; }
        var path = (0, lodash_1.isObject)(name) ? name.url : name;
        return this.instance.post(path, data, config).then(function (res) {
            // data存在并且请求失败，不为登录失效则处理报错信息
            if ((0, lodash_1.isFunction)(_this.isOffline) && _this.isOffline()) {
                return Promise.reject();
            }
            if ((0, lodash_1.isBoolean)(_this.isOffline) && _this.isOffline) {
                return Promise.reject();
            }
            if (_this.native) {
                return Promise.resolve(res);
            }
            else {
                if (res.data && res.data.status === 'fail' && res.data.result !== 'authErr') {
                    if (_this.whiteList.find(function (val) { return val.name === path && val.err.find(function (item) { return item === res.data.result; }); })) {
                    }
                    else {
                        res.data.result = _this.errMsg(res.data.result, errCode) || res.data.result;
                    }
                }
                return Promise.resolve(res.data);
            }
        });
    };
    WebHttpService.prototype.errMsg = function (errStr, errCode) {
        var _this = this;
        var codeMsg = '';
        var commonMsg = '';
        var errJson = {};
        try {
            errJson = JSON.parse(errStr);
            Object.keys(errJson).forEach(function (erk) {
                // 获取字段的错误code是否存在
                codeMsg = (0, lodash_1.get)(_this.errMap, "".concat(errCode, ".").concat(erk + errJson[erk]));
                // 字段错误不存在则获取公共错误
                !codeMsg && (commonMsg = (0, lodash_1.get)(_this.errMapCommon, "".concat(errJson[erk])));
                // 赋值取字段错误/公共错误/默认错误
                errJson[erk] = codeMsg || commonMsg || errJson[erk];
                // 如果字段错误不存在，公共错误存在则直接提示公共错误，不在字段中进行展示
                if (_this.errorMessage) {
                    if (!codeMsg && commonMsg) {
                        if (_this.errorMessage) {
                            _this.errorMessage(errJson[erk]);
                        }
                    }
                    else {
                        _this.errorMessage(errJson[erk]);
                    }
                }
            });
        }
        catch (e) {
            // 解析失败则获取公共错误并直接展示
            errJson = (0, lodash_1.get)(this.errMap, "".concat(errCode, ".").concat(errStr));
            if (!errJson) {
                errJson = (0, lodash_1.get)(this.errMapCommon, "".concat(errStr), errStr);
            }
            if (this.errorMessage) {
                this.errorMessage(errJson);
            }
        }
        return errJson;
    };
    return WebHttpService;
}(HttpService_1.default));
exports.default = WebHttpService;
//# sourceMappingURL=index.js.map